import Vue from 'vue'
import Router from 'vue-router'
import axios from '@/axios'

Vue.use(Router)

export const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			beforeEnter: auth,
			component: () => import('@/pages/public/Home.vue')
		},
		{
			path: '/inicio',
			beforeEnter: auth,
			component: () => import('@/pages/public/Home.vue')
		},
		{
			path: '/login',
			component: () => import('@/pages/login/Login.vue')
		},
		{
			path: '/password_recovery',
			component: () => import('@/pages/login/PasswordRecovery.vue')
		},
		{
			path: '/password_reset/:token',
			props: true,
			component: () => import('@/pages/login/PasswordReset.vue')
		},
		{
			path: '/oauth',
			component: () => import('@/pages/login/Oauth.vue')
		},
		{
			path: '/noticias',
			beforeEnter: auth,
			component: () => import('@/pages/public/News.vue')
		},
		{
			path: '/noticias/:id',
			beforeEnter: auth,
			props: true,
			component: () => import('@/pages/public/NewsSingle.vue')
		},
		{
			path: '/bonos',
			beforeEnter: auth,
			component: () => import('@/pages/public/Bonuses.vue')
		},
		{
			path: '/contactos',
			beforeEnter: auth,
			component: () => import('@/pages/public/Contacts.vue')
		},
		{
			path: '/admin',
			beforeEnter: admin,
			component: () => import('@/pages/admin/Base.vue'),
			children: [
				{
					path: 'alta-usuarios',
					component: () => import('@/pages/admin/UserUploadFile.vue')
				},
				{
					path: 'generar-firmas',
					component: () => import('@/pages/admin/GenerateSignsAdmin.vue')
				},
				{
					path: 'emails',
					component: () => import('@/pages/admin/EmailsAdmin.vue')
				},
				{
					path: 'listado/noticias',
					component: () => import('@/pages/admin/NewsListAdmin.vue')
				},
				{
					path: 'listado/categoria',
					component: () => import('@/pages/public/Category.vue')
				},
				{
					path: 'listado/categoria/:id',
					props: true,
					component: () => import('@/pages/public/Category.vue')
				},
				{
					path: 'noticias',
					props: true,
					component: () => import('@/pages/admin/NewsSingleAdmin.vue'),
					children: [
						{
							path: ':id',
							props: true,
							component: () => import('@/pages/admin/NewsSingleAdmin.vue')
						}
					]
				},
				{
					path: 'listado/noticias-categorias',
					component: () => import('@/pages/admin/NewsCategoryListAdmin.vue')
				},
				{
					path: 'noticias-categorias',
					props: true,
					component: () => import('@/pages/admin/NewsCategorySingleAdmin.vue'),
					children: [
						{
							path: ':id',
							props: true,
							component: () =>
								import('@/pages/admin/NewsCategorySingleAdmin.vue')
						}
					]
				},
				{
					path: 'banners/',
					props: true,
					component: () => import('@/pages/admin/BannersSingleAdmin.vue')
				},
				{
					path: 'banners/:id',
					props: true,
					component: () => import('@/pages/admin/BannersSingleAdmin.vue')
				},
				{
					path: 'listado/banners',
					component: () => import('@/pages/admin/BannersListAdmin.vue')
				},
				{
					path: 'links/',
					props: true,
					component: () => import('@/pages/admin/LinksSingleAdmin.vue')
				},
				{
					path: 'links/:id',
					props: true,
					component: () => import('@/pages/admin/LinksSingleAdmin.vue')
				},
				{
					path: 'listado/links',
					component: () => import('@/pages/admin/LinksListAdmin.vue')
				},
				{
					path: 'listado/bonos',
					component: () => import('@/pages/admin/BonusesListAdmin.vue')
				},
				{
					path: 'bonos/',
					props: true,
					component: () => import('@/pages/admin/BonusesSingleAdmin.vue')
				},
				{
					path: 'bonos/:id',
					props: true,
					component: () => import('@/pages/admin/BonusesSingleAdmin.vue')
				},
				{
					path: 'listado/empresas',
					component: () => import('@/pages/admin/CompaniesListAdmin.vue')
				},
				{
					path: 'empresas/',
					props: true,
					component: () => import('@/pages/admin/CompaniesSingleAdmin.vue')
				},
				{
					path: 'empresas/:id',
					props: true,
					component: () => import('@/pages/admin/CompaniesSingleAdmin.vue')
				},
				{
					path: 'listado/contactos',
					component: () => import('@/pages/admin/ContactsListAdmin.vue')
				},
				{
					path: 'contactos/',
					props: true,
					component: () => import('@/pages/admin/ContactsSingleAdmin.vue'),
					children: [
						{
							path: ':id',
							props: true,
							component: () => import('@/pages/admin/ContactsSingleAdmin.vue')
						}
					]
				},
				{
					path: 'listado/contactos-categorias',
					component: () => import('@/pages/admin/ContactsCategoryListAdmin.vue')
				},
				{
					path: 'contactos-categorias',
					props: true,
					component: () =>
						import('@/pages/admin/ContactsCategorySingleAdmin.vue'),
					children: [
						{
							path: ':id',
							props: true,
							component: () =>
								import('@/pages/admin/ContactsCategorySingleAdmin.vue')
						}
					]
				},
				{
					path: 'listado/organizaciones',
					component: () => import('@/pages/admin/OrganizationsListAdmin.vue')
				},
				{
					path: 'organizaciones/',
					props: true,
					component: () => import('@/pages/admin/OrganizationsSingleAdmin.vue')
				},
				{
					path: 'organizaciones/:id',
					props: true,
					component: () => import('@/pages/admin/OrganizationsSingleAdmin.vue')
				},
				{
					path: 'listado/delegaciones',
					component: () => import('@/pages/admin/DelegationsListAdmin.vue')
				},
				{
					path: 'delegacion/',
					props: true,
					component: () => import('@/pages/admin/DelegationsSingleAdmin.vue')
				},
				{
					path: 'delegacion/:id',
					props: true,
					component: () => import('@/pages/admin/DelegationsSingleAdmin.vue')
				},
				{
					path: 'listado/oficinas/:id',
					props: true,
					component: () => import('@/pages/admin/OfficesListAdmin.vue')
				},
				{
					path: 'oficina/:delegation_id',
					props: true,
					component: () => import('@/pages/admin/OfficesSingleAdmin.vue')
				},
				{
					path: 'oficina/:delegation_id/:id',
					props: true,
					component: () => import('@/pages/admin/OfficesSingleAdmin.vue')
				},
				{
					path: 'listado/provincias',
					component: () => import('@/pages/admin/StatesListAdmin.vue')
				},
				{
					path: 'provincia/',
					props: true,
					component: () => import('@/pages/admin/StatesSingleAdmin.vue')
				},
				{
					path: 'provincia/:id',
					props: true,
					component: () => import('@/pages/admin/StatesSingleAdmin.vue')
				},
				{
					path: 'listado/roles',
					component: () => import('@/pages/admin/RolesListAdmin.vue')
				},
				{
					path: 'roles/',
					props: true,
					component: () => import('@/pages/admin/RolesSingleAdmin.vue')
				},
				{
					path: 'roles/:id',
					props: true,
					component: () => import('@/pages/admin/RolesSingleAdmin.vue')
				},
				{
					path: 'listado/usuarios',
					component: () => import('@/pages/admin/UsersListAdmin.vue')
				},
				{
					path: 'usuarios/:id',
					props: true,
					component: () => import('@/pages/admin/UserSingleAdmin.vue')
				},
				{
					path: 'usuarios',
					props: true,
					component: () => import('@/pages/admin/UserSingleAdmin.vue')
				},
				{
					path: 'listado/contratos',
					component: () => import('@/pages/admin/ContratacionListAdmin.vue')
				},
				{
					path: 'listado/contrato',
					props: true,
					component: () => import('@/pages/admin/ContratacionSingleAdmin.vue'),
					children: [
						{
							path: ':id',
							props: true,
							component: () =>
								import('@/pages/admin/ContratacionSingleAdmin.vue')
						}
					]
				},
				{
					path: 'listado/configuracion',
					component: () => import('@/pages/admin/ContratacionConfiguration.vue')
				},
				{
					path: 'listado/plantillas',
					component: () => import('@/pages/admin/TemplatesListAdmin.vue')
				},
				{
					path: 'plantilla/:id',
					props: true,
					component: () => import('@/pages/admin/TemplateSingleAdmin.vue')
				},
				{
					path: 'plantilla',
					props: true,
					component: () => import('@/pages/admin/TemplateSingleAdmin.vue')
				},
				{
					path: 'listado/variables',
					component: () => import('@/pages/admin/FieldsListAdmin.vue')
				},
				{
					path: 'variable/:id',
					props: true,
					component: () => import('@/pages/admin/FieldSingleAdmin.vue')
				},
				{
					path: 'variable',
					props: true,
					component: () => import('@/pages/admin/FieldSingleAdmin.vue')
				},
				{
					path: 'listado/campaigns',
					component: () => import('@/pages/admin/CampaignsListAdmin.vue')
				},
				{
					path: 'campaign/:id',
					props: true,
					component: () => import('@/pages/admin/CampaignSingleAdmin.vue')
				},
				{
					path: 'campaign',
					props: true,
					component: () => import('@/pages/admin/CampaignSingleAdmin.vue')
				},
				{
					path: 'listado/tipos_contrato',
					component: () => import('@/pages/admin/ContractTypesListAdmin.vue')
				},
				{
					path: 'tipos_contrato/:id',
					props: true,
					component: () => import('@/pages/admin/ContractTypeSingleAdmin.vue')
				},
				{
					path: 'tipos_contrato',
					props: true,
					component: () => import('@/pages/admin/ContractTypeSingleAdmin.vue')
				},
				{
					path: 'listado/base_comercial',
					component: () => import('@/pages/admin/ComercialBasesListAdmin.vue')
				},
				{
					path: 'base_comercial/:id',
					props: true,
					component: () => import('@/pages/admin/ComercialBaseSingleAdmin.vue')
				},
				{
					path: 'base_comercial',
					props: true,
					component: () => import('@/pages/admin/ComercialBaseSingleAdmin.vue')
				}
			]
		},
		{
			path: '/contratacion',
			component: () => import('@/pages/contratacion/contratacion.vue')
		},
		{
			path: '/admin/contrato',
			props: true,
			component: () => import('@/pages/admin/ContratacionSingleAdmin.vue'),
			children: [
				{
					path: ':id',
					props: true,
					component: () => import('@/pages/admin/ContratacionSingleAdmin.vue')
				}
			]
		},
		{
			path: '/profile',
			component: () => import('@/pages/profile/Base.vue'),
			children: [
				{
					path: '/',
					component: () => import('@/pages/profile/Profile.vue')
				},
				{
					path: 'change_password',
					component: () => import('@/pages/profile/changePassword.vue')
				}
			]
		},
		{
			path: '/*',
			beforeEnter: auth,
			component: () => import('@/pages/404.vue')
		}
	]
})

// Comprueba con un endpoint que el token guardado en el state sea válido
function auth(_from, _to, next) {
	const vuex = JSON.parse(localStorage.getItem('vuex'))
	if (!vuex) {
		next('/login')
	} else if (!vuex.login.token) {
		localStorage.removeItem('vuex')
		location.reload()
		next('/login')
	} else {
		axios
			.get('/dummy')
			.then(() => next())
			.catch(() => {
				if (localStorage.getItem('vuex')) {
					localStorage.removeItem('vuex')
					location.reload()
				}
				next('/login')
			})
	}
}

function admin(_to, _from, next) {
	const vuex =
		localStorage.getItem('vuex') && JSON.parse(localStorage.getItem('vuex'))

	if (!vuex || !vuex.login.user || !vuex.login.user.role.is_administrator)
		next('/inicio')

	next()
}

export default router
